import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { metrics } from '@atlassian/browser-metrics';
import type { Attributes } from '@atlassian/jira-product-analytics-bridge';
import { isLoaderError } from '@atlassian/react-loosely-lazy';
import { JIRA_UPFLOW_TOUCHPOINT } from './constants.tsx';

type JiraUpFlowIframeAnalyticsAttributes = {
	subject: 'fetchCcpProductUpgradeUrl' | 'fetchCommerceRolloutInformation';
	message: string;
};

export const fireErrorAnalytic = (
	attributes: JiraUpFlowIframeAnalyticsAttributes,
	error?: Error,
): void => {
	fireErrorAnalytics({
		meta: {
			// We use the same ID for all errors in the package for easier
			// management in data portal, and use attributes to identify an error instead.
			id: JIRA_UPFLOW_TOUCHPOINT,
			packageName: JIRA_UPFLOW_TOUCHPOINT,
			teamName: 'luna-growth',
		},
		attributes: {
			...attributes,
		},
		error,
	});
};

export const jiraUpFlowTouchpointUpgradePlanInteraction = metrics.interaction({
	key: `${JIRA_UPFLOW_TOUCHPOINT}.upgrade.plan`,
});

export const addChunkLoadErrorAnalyticsAttribute = (error: Error): Attributes => ({
	chunkLoadError: isLoaderError(error),
});
